import React from 'react';
import Layout from '../../components/layout/Layout';

const BuyerWallet = () => {
  return (
    <div title="My Wallet">
      <div style={{ maxWidth: '1200px', margin: '0 auto', padding: '32px 24px' }}>
        <div style={{
          background: 'var(--bg-card)',
          padding: '32px',
          borderRadius: '12px',
          border: '1px solid var(--border)'
        }}>
          <h2 style={{ 
            fontFamily: 'Outfit, sans-serif',
            fontWeight: '700', 
            fontSize: '20px', 
            marginBottom: '16px',
            color: 'var(--text)'
          }}>
            Wallet & Earnings
          </h2>
          <p style={{ fontSize: '14px', color: 'var(--text-muted)' }}>
            Buyer wallet page with earnings summary and transaction history - To be implemented
          </p>
        </div>
      </div>
    </div>
  );
};

export default BuyerWallet;
